import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail, LOGO_URL } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Ciara's Kidz" className="h-20 w-auto mx-auto object-contain" />
          <h1 className="font-display text-2xl font-bold text-purple-950 mt-4">Join Ciara's Kidz</h1>
          <p className="text-muted-foreground text-sm mt-1">Create an account to track orders and history.</p>
        </div>
        <form onSubmit={submit} data-testid="register-form" className="bg-white rounded-3xl border border-purple-100 p-8 shadow-xl shadow-purple-100/50 space-y-4">
          {error && (
            <div data-testid="register-error" className="rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3">
              {error}
            </div>
          )}
          <div>
            <Label>Full Name</Label>
            <Input data-testid="register-name-input" required value={form.name} onChange={upd("name")} placeholder="Jane Doe" className="mt-1.5 bg-white" />
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="register-email-input" type="email" required value={form.email} onChange={upd("email")} placeholder="you@example.com" className="mt-1.5 bg-white" />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={upd("password")} placeholder="At least 6 characters" className="mt-1.5 bg-white" />
          </div>
          <button
            type="submit"
            data-testid="register-submit-button"
            disabled={loading}
            className="w-full py-3.5 rounded-full brand-gradient text-white font-semibold hover:opacity-90 transition disabled:opacity-50"
          >
            {loading ? "Creating account..." : "Create Account"}
          </button>
          <p className="text-center text-sm text-muted-foreground">
            Already have an account?{" "}
            <Link to="/login" className="text-fuchsia-600 font-semibold hover:underline">
              Log in
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
